<template>
  <div>
    <input ref="copy" type="text" v-bind:value="rawLink" class="d-none"/>
    <div class="row g-0">
      <a v-if="isEnabled('send')" href="#sendtocolleague" v-bind:title="bundle.id_8322" class="col-auto sobu sobu-send">
        <i class="fas fa-envelope"></i>
      </a>
      <a v-if="isEnabled('copy')" v-bind:href="rawLink" v-bind:title="bundle.id_11295" target="_blank"
         v-on:click.prevent="copy()" class="col-auto sobu sobu-copy">
        <i class="fal fa-link"></i>
      </a>
      <a v-if="isEnabled('facebook')" v-bind:href="facebook" v-bind:title="bundle.id_9625" target="_blank"
         v-on:click.prevent="open(facebook)" class="col-auto sobu sobu-facebook">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a v-if="isEnabled('twitter')" v-bind:href="twitter" v-bind:title="bundle.id_9626" target="_blank"
         v-on:click.prevent="open(twitter)" class="col-auto sobu sobu-twitter">
        <i class="fab fa-twitter"></i>
      </a>
      <a v-if="isEnabled('linkedin')" v-bind:href="linkedin" v-bind:title="bundle.id_9627" target="_blank"
         v-on:click.prevent="open(linkedin)" class="col-auto sobu sobu-linkedin">
        <i class="fab fa-linkedin-in"></i>
      </a>
      <a v-if="isEnabled('print')" v-bind:href="rawLink" v-bind:title="bundle.id_119" target="_blank"
         v-on:click.prevent="print()" class="col-auto sobu sobu-print">
        <i class="fal fa-print"></i>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import MediaWidth from "../plugins/media-width"

Vue.use(MediaWidth)
export default {
  name: "social-buttons",
  props: ["value"],
  data: function () {
    return {
      bundle: {
        id_119: "Print page",
        id_8322: "Send to a colleague",
        id_9625: "Share on Facebook",
        id_9626: "Share on Twitter",
        id_9627: "Share on LinkedIn",
        id_11295: "Copy link"
      }
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  },
  computed: {
    rawLink: function () {
      // return this.value ? this.value : window.location;
      return window.location;
    },
    link: function () {
      return encodeURI(this.rawLink);
    },
    title: function () {
      return encodeURI(document.title);
    },
    facebook: function () {
      return "https://www.facebook.com/sharer.php?t=" + this.title + "&u=" + this.link;
    },
    twitter: function () {
      return "https://twitter.com/intent/tweet?url=" + this.link;
    },
    linkedin: function () {
      return "https://www.linkedin.com/sharing/share-offsite/?url=" + this.link;
    },
    valueArray: function () {
      if (!this.value) {
        return [];
      }
      if (this.value instanceof Array) {
        return this.value;
      }
      return this.value.replace(/\s/g, '').split(",");
    },
  },
  methods: {
    isEnabled: function (service) {
      return this.valueArray.indexOf(service) != -1;
    },
    copy: function () {
      this.$refs.copy.select();
      this.$refs.copy.setSelectionRange(0, this.rawLink.length);
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.$refs.copy.value);
      } else {
        // Developer hint: In chrome://flags, enable 'Insecure origins treated as secure' to test the copy function.
        console.log("Could not copy the link. Maybe you are not running in a secure context like HTTPS or localhost.")
      }
    },
    open: function (url) {
      const phone = Vue.$mediaWidth() == "xs";
      if (phone) {
        return window.open(url, '_blank');
      } else {
        const wh = window.innerHeight;
        const ww = window.innerWidth;
        const h = Math.min(600, .6 * wh);
        const w = Math.min(800, .8 * ww);
        return window.open(url, '', ["height=" + h, "left=" + ((ww - w) / 2), "top=" + ((wh - h) / 2), "width=" + w, 'status=1', 'toolbar=0'].join(','));
      }
    },
    print: function () {
      window.print();
    }
  }
}
</script>

<style lang="less">
.sobu {
  border-radius: 50%;
  color: #fff;
  display: inline-block;
  font-size: 14px;
  height: 30px;
  margin: 0 2px 5px 2px;
  padding: 5px 0;
  text-align: center;
  width: 30px;
  line-height: 20px;
  transition: all .2s ease-in-out;

  &.sobu-send {
    background-color: #7d7d7d;
  }

  &.sobu-copy {
    background-color: #178bf4;
  }

  &.sobu-facebook {
    background-color: #3b5998;
  }

  &.sobu-twitter {
    background-color: #1da1f2;
  }

  &.sobu-linkedin {
    background-color: #0077B5;
  }

  &.sobu-print {
    background-color: #2f4f4f;
  }

  &:active, &:hover {
    transform: translateY(-4px);
    color: #fff;
    text-decoration: none;
  }
}
</style>